// extracted by mini-css-extract-plugin
module.exports = {"inputs":"inputs_inputs__1eMlJ","company":"inputs_company__1ogzD","left":"inputs_left__ZwGp2","closeIcon":"inputs_closeIcon__2rOBw","horizontal":"inputs_horizontal__1TC6j"};